import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';
import { Flow } from '../../models/Flow';


@Injectable({
  providedIn: 'root'
})

export class ReviewCommentsService {
  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls;
  constructor(private httpService: TCCPHttpService, private logger: TCCPLoggerService) { }


  /** For service call to get flow
* @class AdminService
* @method getSubFeatureFlow
* @param flowId - flow id
* @returns Observable
*/
  getSubFeatureFlow(flowId: string, division: string): Observable< any > {
    const selectedApplication = division.toLowerCase();
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.baseURL['GET_SUBFEATURE_FLOW'] + '?issueId=' + flowId + '&source=' + selectedApplication;
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to get flow
    * @class ReviewCommentsService
    * @method addReviewComments
    * @param ReviewCommentsRequest
    * @returns Observable
    */


  addReviewComments(flow: Flow, source) {
    const url = this.baseURL['UPDATE_SUBFEATURE_FLOW'] + '?source=' + source.toLowerCase();
    return this.httpService.put(url, flow).pipe(
      map((data: any) => {
          this.logger.logMethodEnd('Add Review Comments', 'Review comments update', 'review comments successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException('Add Review Comments', 'Review comments update', 'review comments failed', '', error);
          return error;
        })
    );
  }

}
